import type { Option, OptionsGroup, OptionsGroupList } from './types';
import type { DataAttrs } from '@uikit/types';

export function getOptionGroups(groups: OptionsGroupList = [], options: Option[] = []): OptionsGroup[] {
    if (groups.length && options.length) {
        throw new Error('Select: Cannot pass both options and optionsGroups. Prefer optionsGroups.');
    }
    if (groups.length) {
        return groups.reduce((result, value) => {
            if (!Array.isArray(value)) {
                if (value.options.length) {
                    result.push(value);
                }
            } else if (value.length) {
                result.push({ options: value });
            }
            return result;
        }, [] as OptionsGroup[]);
    } else if (options.length) {
        return [{ options }];
    } else {
        return [];
    }
}

export function hasOptions(groups: OptionsGroup[]): boolean {
    for (const { options } of groups) {
        if (options.length) {
            return true;
        }
    }
    return false;
}

export function getOptionByValue(options: OptionsGroup[], value: string): Option | undefined {
    return options.flatMap(({ options }) => options).find((option) => option.value === value);
}

export function mappedSelectOptions(attrs: Partial<DataAttrs>, id: number | string) {
    return Object.fromEntries(Object.entries(attrs).map(([key, value]) => [key, `${value}${id}`]));
}
